import { sileo, type SileoOptions } from 'sileo';

export type ToastType = 'success' | 'error' | 'warning' | 'info' | 'action';
type PromiseOptions<T> = Parameters<typeof sileo.promise<T>>[1];

export interface ToastOptions extends SileoOptions {
  type?: ToastType;
}

export function useToast() {
  const toast = {
    success: (options: ToastOptions) => sileo.success(options),
    error: (options: ToastOptions) => sileo.error(options),
    warning: (options: ToastOptions) => sileo.warning(options),
    info: (options: ToastOptions) => sileo.info(options),
    action: (options: ToastOptions) => sileo.action(options),
    promise: <T>(promise: Promise<T>, options: PromiseOptions<T>) =>
      sileo.promise(promise, options),
    dismiss: (id: string) => sileo.dismiss(id),
    clear: (position?: Parameters<typeof sileo.clear>[0]) => sileo.clear(position),
  };

  return { toast };
}
